import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"margin-top":"1vh"} }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12 text-center" }
const _hoisted_4 = { class: "absolute-full flex flex-center bg-negative text-white text-subtitle2" }
const _hoisted_5 = {
  class: "row app-center-content-horizontal",
  style: {"margin-top":"1rem"}
}
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-sm-2 col-md-3 app__label--small text-right q-pa-sm" }
const _hoisted_8 = { class: "col-sm-10 col-md-9 app__property--medium text-left q-pa-sm" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-sm-2 col-md-3 app__label--small text-right q-pa-sm" }
const _hoisted_11 = { class: "col-sm-10 col-md-9 app__property--medium text-left q-pa-sm" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-sm-2 col-md-3 app__label--small text-right q-pa-sm" }
const _hoisted_14 = { class: "col-sm-10 col-md-9 app__property--medium text-left q-pa-sm" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col-sm-2 col-md-3 app__label--small text-right q-pa-sm" }
const _hoisted_17 = { class: "col-sm-10 col-md-9 app__property--medium text-left q-pa-sm" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col-sm-2 col-md-3 app__label--small text-right q-pa-sm" }
const _hoisted_20 = { class: "col-sm-10 col-md-9 app__property--medium text-left q-pa-sm" }
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "col-sm-2 col-md-3 app__label--small text-right q-pa-sm" }
const _hoisted_23 = { class: "col-sm-10 col-md-9 app__property--medium text-left q-pa-sm" }
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "col-sm-2 col-md-3 app__label--small text-right q-pa-sm" }
const _hoisted_26 = { class: "col-sm-10 col-md-9 app__property--medium text-left q-pa-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_avatar = _resolveComponent("q-avatar")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_q_avatar, { size: "7rem" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_img, {
              src: _ctx.urlUserImgProfileByAppid,
              style: {"height":"7rem","max-width":"7rem"}
            }, {
              error: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('message.no_image')), 1)
              ]),
              _: 1
            }, 8, ["src"])
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_q_btn, {
        flat: "",
        color: "primary",
        label: _ctx.$t('message.reset_password'),
        onClick: _ctx.resetPassword
      }, null, 8, ["label", "onClick"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('message.user_id')), 1),
      _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.user.userid), 1)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('message.company')), 1),
      _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.user.companyName), 1)
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('message.company_id')), 1),
      _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.user.companyCode), 1)
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('message.first_name')), 1),
      _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.user.firstName), 1)
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('message.last_name')), 1),
      _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.user.lastName), 1)
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('message.email')), 1),
      _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.user.emailAddress), 1)
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t('message.phone')), 1),
      _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.user.phoneNr), 1)
    ])
  ]))
}